<template>
  <div class="row">
    <!-- Map -->
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12 text-right">
          <base-button
            class="btn-success text-default"
            @click="createWorkOrder()"
          >
            Create Work Order <br />
          </base-button>
        </div>
        <div class="col-lg-12">
          <card class="card-plain" type="chart">
            <loading
              loader="spinner"
              :height="40"
          :width="40"
              color="#00f2c3"
              background-color="#6c757d"
              transition="fade"
              :active="isLoading"
              :is-full-page="false"
            ></loading>
            <template slot="header">
              <h3 class="card-title">
                <div id="map" class="map" style="height: 773px">
                  <base-button
                    @click="show = true"
                    id="menuButton"
                    class="btn-vue btn-link btn-icon"
                    ><i class="fa fa-bars"></i
                  ></base-button>
                  <l-map
                    id="map"
                    ref="map"
                    @ready="attachSidebar"
                    :zoom="zoom"
                    :center="center"
                    :bounds="bounds"
                    class="sidebar-map map"
                  >
                    <i
                      style="color: #344675; text-align: center"
                      class="tim-icons icon-simple-remove"
                      @click="show = false"
                    ></i>
                    <l-tile-layer
                      :url="url"
                      :attribution="attribution"
                    ></l-tile-layer>
                    <!-- <el-drawer
                      class="drawer"
                      :visible.sync="show"
                      :with-header="false"
                      direction="ltr"
                      size="450px"
                      style="padding: 15px"
                    >
                      <div
                        class="row"
                        style="
                          background-color: #27293d;
                          height: 100%;
                          padding: 15px;
                        "
                      >
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-10">
                              <h4 style="text-align: left; font-size: 18px">
                                List of new faults (
                                <h4
                                  style="
                                    color: #d525c7;
                                    display: inline;
                                    font-size: 18px;
                                  "
                                >
                                  {{ totalDeviceFault }}
                                </h4>
                                ) (
                                <h4
                                  style="
                                    color: #00f2c3;
                                    display: inline;
                                    font-size: 18px;
                                  "
                                >
                                  {{ totalGWFault }}
                                </h4>
                                )
                              </h4>
                            </div>
                            <div class="col-lg-2">
                              <i
                                style="
                                  text-align: right;
                                  padding-top: 5px;
                                  padding-left: 35px;
                                "
                                class="tim-icons icon-simple-remove"
                                @click="show = false"
                              ></i>
                            </div>
                          </div>
                          <div class="row">
                            <div
                              class="col-lg-12"
                              style="height: 670px; overflow: auto"
                            >
                              <card
                                class="card-white"
                                type="chart"
                                :style="item.bordercolor"
                                v-for="item in faults"
                                :key="item.id"
                              >
                                <h4 class="card-title">
                                  {{ item.clustername }} |
                                  <h4
                                    :style="item.ticketissue"
                                    style="display: inline"
                                  >
                                    {{ item.issue }} | {{ item.failure }}
                                  </h4>
                                </h4>
                                
                                <div class="row">
                                  <div class="col-lg card-style">
                                    <h5>Light:</h5>
                                  </div>
                                  <div class="col-lg card-style">
                                    <h5>{{ item.light }}</h5>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg card-style">
                                    <h5>Type:</h5>
                                  </div>
                                  <div class="col-lg card-style">
                                    <h5>{{ item.type }}</h5>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg card-style">
                                    <h5>Fault:</h5>
                                  </div>
                                  <div class="col-lg card-style">
                                    <h5>{{ item.fault }}</h5>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg card-style">
                                    <h5>Feeder pillar:</h5>
                                  </div>
                                  <div class="col-lg card-style">
                                    <h5 :style="item.ticketissue">
                                      {{ item.feederpillar }}
                                    </h5>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg card-style">
                                    <h5>Time of fault:</h5>
                                  </div>
                                  <div class="col-lg card-style">
                                    <h5>{{ item.faulttime }}</h5>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg card-style">
                                    <h5>Date of fault:</h5>
                                  </div>
                                  <div class="col-lg card-style">
                                    <h5>{{ item.faultdate }}</h5>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg card-style">
                                    <h5>Contractor:</h5>
                                  </div>
                                  <div class="col-lg card-style">
                                    <h5>{{ item.contractor }}</h5>
                                  </div>
                                </div>
                                <base-button
                                  class="btn-vue"
                                  @click="viewWorkOrder(item)"
                                  >View Work Order</base-button
                                >

                               
                              </card>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-drawer> -->
                    <div id="sidebar" class="leaflet-sidebar collapsed" style="background-color: #27293d; z-index: 999;" >
                      <!-- Nav tabs -->
                      <div
                        class="leaflet-sidebar-tabs"
                        style="background-color: transparent; color: #ffffff"
                      >
                        <ul
                          role="tablist"
                          style="background-color: #27293d; color: #ffffff"
                        >
                          <!-- top aligned tabs -->
                          <li style="background-color: #27293d; color: #ffffff">
                            <a href="#home" role="tab"
                              ><i class="fa fa-bars"></i
                            ></a>
                          </li>
                          <!-- <li class="disabled">
                            <a href="#messages" role="tab"
                              ><i class="fa fa-envelope"></i
                            ></a>
                          </li>
                          <li>
                            <a href="#profile" role="tab"
                              ><i class="fa fa-user"></i
                            ></a>
                          </li> -->
                        </ul>

                        <ul role="tablist">
                          <!-- bottom aligned tabs -->
                          <li>
                            <a href="#settings" role="tab"
                              ><i class="fa fa-gear"></i
                            ></a>
                          </li>
                        </ul>
                      </div>

                      <!-- Tab panes -->
                      <div
                        class="leaflet-sidebar-content"
                        style="background-color: #27293d"
                      >
                        <div class="leaflet-sidebar-pane" id="home">
                          <h1
                            class="leaflet-sidebar-header"
                            style="background-color: #27293d; color: #ffffff:"
                          >
                            <div
                              class="leaflet-sidebar-close"
                              style="color: #ffffff"
                            >
                              <i class="tim-icons icon-simple-remove"></i>
                            </div>
                          </h1>
                          <!-- <p>A responsive sidebar for mapping libraries</p> -->
                          <div class="row">
                            <!-- style="
                          background-color: #27293d;
                          height: 100%;
                          padding: 15px;
                        " -->
                            <div class="col-lg-12">
                              <div class="row">
                                <div class="col-lg-10">
                                  <h4 style="text-align: left; font-size: 18px">
                                    List of new faults (
                                    <h4
                                      style="
                                        color: #d525c7;
                                        display: inline;
                                        font-size: 18px;
                                      "
                                    >
                                      {{ totalDeviceFault }}
                                    </h4>
                                    ) (
                                    <h4
                                      style="
                                        color: #00f2c3;
                                        display: inline;
                                        font-size: 18px;
                                      "
                                    >
                                      {{ totalGWFault }}
                                    </h4>
                                    )
                                  </h4>
                                </div>
                                <!-- <div class="col-lg-2">
                              <i
                                style="
                                  text-align: right;
                                  padding-top: 5px;
                                  padding-left: 35px;
                                "
                                class="tim-icons icon-simple-remove"
                                @click="show = false"
                              ></i>
                            </div> -->
                              </div>
                              <div class="row" style="padding-right: 20px;height: 580px; overflow: auto ;">
                                <div class="col-lg-12" >
                                  <!-- style=" -->
                                  <card
                                    class="card-white"
                                    type="chart"
                                    :style="item.bordercolor"
                                    v-for="item in faults"
                                    :key="item.id"
                                  >
                                    <h4 class="card-title">
                                      {{ item.clustername }} |
                                      <h4
                                        :style="item.ticketissue"
                                        style="display: inline"
                                      >
                                        {{ item.issue }} | {{ item.failure }}
                                      </h4>
                                    </h4>

                                    <div class="row">
                                      <div class="col-lg card-style">
                                        <h5>Light:</h5>
                                      </div>
                                      <div class="col-lg card-style">
                                        <h5>{{ item.light }}</h5>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg card-style">
                                        <h5>Type:</h5>
                                      </div>
                                      <div class="col-lg card-style">
                                        <h5>{{ item.type }}</h5>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg card-style">
                                        <h5>Fault:</h5>
                                      </div>
                                      <div class="col-lg card-style">
                                        <h5>{{ item.fault }}</h5>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg card-style">
                                        <h5>Feeder pillar:</h5>
                                      </div>
                                      <div class="col-lg card-style">
                                        <h5 :style="item.ticketissue">
                                          {{ item.feederpillar }}
                                        </h5>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg card-style">
                                        <h5>Time of fault:</h5>
                                      </div>
                                      <div class="col-lg card-style">
                                        <h5>{{ item.faulttime }}</h5>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg card-style">
                                        <h5>Date of fault:</h5>
                                      </div>
                                      <div class="col-lg card-style">
                                        <h5>{{ item.faultdate }}</h5>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-lg card-style">
                                        <h5>Contractor:</h5>
                                      </div>
                                      <div class="col-lg card-style">
                                        <h5>{{ item.contractor }}</h5>
                                      </div>
                                    </div>
                                    <base-button
                                      class="btn-vue"
                                      @click="viewWorkOrder(item)"
                                      >View Work Order</base-button
                                    >
                                  </card>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- <div class="leaflet-sidebar-pane" id="messages">
                          <h1 class="leaflet-sidebar-header">
                            Messages
                            <div class="leaflet-sidebar-close">
                              <i class="fa fa-caret-left"></i>
                            </div>
                          </h1>
                        </div>

                        <div class="leaflet-sidebar-pane" id="profile">
                          <h1 class="leaflet-sidebar-header">
                            Profile
                            <div class="leaflet-sidebar-close">
                              <i class="fa fa-caret-left"></i>
                            </div>
                          </h1>
                        </div>  -->
                      </div>
                    </div>
                    <l-marker
                      v-for="marker in markers"
                      :lat-lng="marker.location"
                      :key="marker.addMarker"
                      :icon="markericon()"
                    >
                      <!-- @click="viewCluster(marker.id)" -->
                      <l-tooltip :content="marker.pointName" />
                    </l-marker>
                  </l-map>
                </div>
              </h3>
              <div slot="footer"></div>
            </template>
          </card>
        </div>
      </div>
      <modal
        :show.sync="modals.openticket"
        footer-classes="justify-content-center"
        type="notice"
      >
        <!-- <template slot="header"> -->
        <h3 slot="header" class="modal-title" id="exampleModalLabel">
          Work Order Form
        </h3>
        <!-- </template> -->
        <div>
          <!-- style="background-color: #ffffff;" -->
          <!-- <card> -->
          <div class="row">
            <div class="col-lg-12">
              <base-input label="Device ID" placeholder="Device ID">
                <el-select
                  :disabled="!isWoAdd"
                  class="select-primary"
                  size="large"
                  placeholder="Device ID"
                  v-model="selects.simple_device"
                  @change="setDetails()"
                >
                  <el-option
                    v-for="option in selects.devices"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-lg-4">
              <base-input label="Contractor" placeholder="Contractor">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Contractor"
                  v-model="selects.simple_contractor"
                >
                  <el-option
                    v-for="option in selects.contractors"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-lg-8">
              <base-input
                label="Source of Complaint"
                placeholder="Source of Complaint"
              >
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Source of Complaint"
                  v-model="selects.simple_complaint"
                >
                  <el-option
                    v-for="option in selects.complaints"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <base-input label="Type of Fault" placeholder="Type of Fault">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Type of Fault"
                  v-model="selects.simple_fault"
                >
                  <el-option
                    v-for="option in selects.fault"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <base-input
                label="Time of Fault"
                placeholder="Time of Fault"
                v-model="timefault"
              >
                <el-time-select
                  v-model="timefault"
                  picker-options="{
                                                start: '08:30',
                                                step: '00:15',
                                                end: '00:15',
                                              }"
                >
                </el-time-select>
              </base-input>
            </div>
            <div class="col-lg-8">
              <base-input label="Date of Fault" placeholder="Date of Fault">
                <el-date-picker
                  type="date"
                  placeholder="Start Date..."
                  v-model="datefault"
                ></el-date-picker>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <base-input
                label="Description of Fault"
                placeholder="Description of Fault"
                v-model="description"
              ></base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <base-input
                label="Location of Device"
                placeholder="Location of Device"
                v-model="location"
                disabled
              ></base-input>
            </div>
            <!-- <div class="col-lg-4">
              <base-input label="Priority" placeholder="Priority">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Priority"
                  v-model="selects.simple_priority"
                >
                  <el-option
                    v-for="option in selects.priorities"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div> -->
          </div>
          <div class="row" v-if="isNode">
            <div class="col-lg-6">
              <base-input
                label="Pole ID"
                placeholder="Pole ID"
                v-model="poleID"
                disabled
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input label="Technology Type" placeholder="Technology Type">
                <el-select
                  class="select-primary"
                  size="large"
                  placeholder="Technology Type"
                  v-model="selects.simple_techType"
                  disabled
                >
                  <el-option
                    v-for="option in selects.techType"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <base-button
                class="btn"
                :disabled="isWoAdd"
                @click="updateWorkOrder()"
                >Save</base-button
              >
              <base-button class="btn-vue" @click="submitWorkOrder()"
                >Submit</base-button
              >
            </div>
          </div>
          <!-- </card> -->
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import BarChart from "@/components/Charts/BarChart";
import * as chartConfigs from "@/components/Charts/config";
// import TaskList from "./TaskList";
// import UserTable from "./UserTable";
// import CountryMapCard from "./CountryMapCard";
import StatsCard from "src/components/Cards/StatsCard";
import swal from "sweetalert2";
import config from "@/config";
import moment from "moment";
import { DoubleBounce } from "vue-loading-spinner";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LTooltip,
} from "vue2-leaflet";
import { TabPane, Tabs, BaseButton, Modal } from "src/components";
import {
  Table,
  TableColumn,
  Drawer,
  Collapse,
  CollapseItem,
  Select,
  Option,
  DatePicker,
  TimeSelect,
} from "element-ui";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import "leaflet-sidebar-v2";
import "leaflet-sidebar-v2/css/leaflet-sidebar.css";

export default {
  components: {
    Modal,
    Loading,
    DoubleBounce,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Drawer.name]: Drawer,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    LineChart,
    StatsCard,
    BaseButton,
    // TaskList,
    // CountryMapCard,
    // UserTable,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    TabPane,
  },
  data() {
    BaseButton;
    return {
      sidebar: null,
      isWoAdd: true,
      totalDeviceFault: 0,
      totalGWFault: 0,
      description: "",
      location: "",
      selects: {
        simple_priority: "minor",
        priorities: [
          {
            value: "major",
            label: "Major",
          },
          {
            value: "minor",
            label: "Minor",
          },
        ],
        simple_fault: "",
        fault: [],
        simple_contractor: "",
        contractors: [],
        simple_complaint: "",
        complaints: [],
        simple_techType: "",
        techType: [],
        simple_device: "",
        devices: [],
      },
      poleID: "",
      timefault: "",
      datefault: "",
      faults: [],
      details: false,
      clustername: "Cluster 01",
      status: "Electrical Fault",
      activeCollaps: "1",
      show: true,
      isLoading: false,
      isNode: true,
      editWOID: 0,
      //   modal create ticket
      modals: {
        openticket: false,
      },
      // Map
      zoom: 10,
      bounds: [L.latLng(2.920715, 101.63724)],
      center: L.latLng(2.920715, 101.63724),
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [
        {
          location: L.latLng(2.920715, 101.63724),
          pointName: "Cluster 01",
          clusterName: "Cluster 01",
        },
      ],
      markericon() {
        return L.icon({
          iconUrl: require("@/assets/img/Electrical fault icon 2.png"),
          // shadowUrl: require("@/assets/img/marker-yellow.png"), //shadow

          iconSize: [30, 30], // size of the icon
          iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
          shadowAnchor: [30, 30], // the same for the shadow
          shadowSize: [30, 30],
          popupAnchor: [-3, -76],
        });
      },
    };
  },
  computed: {},
  methods: {
    setDetails() {
      console.log(this.selects.simple_device);
      let selected = this.selects.simple_device;
      for (let i = 0; i < this.selects.devices.length; i++) {
        if (selected == this.selects.devices[i].value) {
          console.log("MASUK");
          this.location = this.selects.devices[i].location;
          this.poleID = this.selects.devices[i].poleid;
          this.selects.simple_techType = this.selects.devices[i].techType;
        }
      }
      console.log(this.location);
      console.log(this.poleID);
      console.log(this.selects.simple_techType);
    },
    getTenantDevice() {
      this.$http.get(":8002/api/v1/manage/device").then((res) => {
        if (!res.error) {
          let response = res.message.device_list;

          console.log(response);
          this.selects.devices = [];

          for (let i = 0; i < response.length; i++) {
            let device = {
              value: response[i].deviceid,
              label: response[i].devicename,
              location: response[i].locationname,
              poleid: response[i].poleid,
              techType: response[i].techtypeid,
            };
            this.selects.devices.push(device);
          }
        }
      });
    },
    getFaultCode() {
      this.$http.get(":8002/api/v1/setting/fault-code").then((res) => {
        if (!res.error) {
          let response = res.message;
          this.selects.fault = [];

          for (let i = 0; i < response.length; i++) {
            let fault = {
              value: response[i].faultcodeid,
              label: response[i].faultname,
            };
            this.selects.fault.push(fault);
          }
        }
      });
    },
    getSource() {
      this.$http.get(":8002/api/v1/setting/source").then((res) => {
        if (!res.error) {
          let response = res.message;
          this.selects.complaints = [];

          for (let i = 0; i < response.length; i++) {
            let source = {
              value: response[i].sourceid,
              label: response[i].sourcename,
            };
            this.selects.complaints.push(source);
          }
        }
      });
    },
    getContractor() {
      this.$http.get(":8002/api/v1/contractor").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.selects.contractors = [];

          for (let i = 0; i < response.length; i++) {
            let contractor = {
              value: response[i].ContractorID,
              label: response[i].ContractorName,
            };
            this.selects.contractors.push(contractor);
          }
        }
      });
    },
    getTechType() {
      this.$http.get(":8002/api/v1/setting/tech-type").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.selects.techType = [];

          for (let i = 0; i < response.length; i++) {
            let techType = {
              value: response[i].techtypeid,
              label: response[i].techtypename,
            };
            this.selects.techType.push(techType);
          }
        }
      });
    },
    getWorkOrderNew() {
      this.$http.get(":8002/api/v1/work-order/new").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          this.faults = [];
          this.markers = [];
          this.bounds = [];

          this.totalDeviceFault = 0;
          this.totalGWFault = 0;

          for (let i = 0; i < response.length; i++) {
            console.log(response[i].TimestampFault);
            if (response[i].EntityTypeID == 1) {
              let data = {
                id: i + 1,
                deviceID: response[i].EntityID,
                woID: response[i].WorkOrderID,
                clustername: response[i].ClusterName,
                issue: response[i].FaultCtxName,
                light: response[i].DeviceName,
                type: response[i].EntityTypeName,
                fault: response[i].FaultName,
                voltage: "-",
                feederpillar: response[i].FpName,
                faulttime: moment(response[i].TimestampFault).format("hh:mm"),
                faultdate: moment(response[i].TimestampFault).format("LL"),
                bordercolor: "border-left: 10px solid #d525c7",
                ticketissue: "color: #d525c7",
                details: response[i].FaultDetails,
                failure: response[i].FaultName,
                contractor: response[i].ContractorName,
                locationName: response[i].LocationName,
                poleID: response[i].poleID,
                sourceID: response[i].SourceID,
                priority: response[i].Priority,
                techType: response[i].TechTypeName,
                entityTypeID: response[i].EntityTypeID,
              };
              this.totalDeviceFault = this.totalDeviceFault + 1;
              this.faults.push(data);
            } else if (response[i].EntityTypeID == 2) {
              let data = {
                id: i + 1,
                deviceID: response[i].EntityID,
                woID: response[i].WorkOrderID,
                clustername: response[i].ClusterName,
                issue: response[i].FaultCtxName,
                light: response[i].DeviceName,
                type: response[i].EntityTypeName,
                fault: response[i].FaultName,
                voltage: "-",
                feederpillar: response[i].FpName,
                faulttime: moment(response[i].TimestampFault).format("hh:mm"),
                faultdate: moment(response[i].TimestampFault).format("LL"),
                bordercolor: "border-left: 10px solid #15acc9",
                ticketissue: "color: #15acc9",
                details: response[i].FaultDetails,
                failure: response[i].FaultName,
                contractor: response[i].ContractorName,
                locationName: response[i].LocationName,
                poleID: response[i].poleID,
                sourceID: response[i].SourceID,
                priority: response[i].Priority,
                techType: response[i].TechTypeName,
                entityTypeID: response[i].EntityTypeID,
              };
              this.totalGWFault = this.totalGWFault + 1;
              this.faults.push(data);
            }

            let marker = {
              location: L.latLng(response[i].Latitude, response[i].Longitude),
              pointName: response[i].DeviceName,
            };

            this.bounds.push(
              L.latLng(response[i].Latitude, response[i].Longitude)
            );

            this.markers.push(marker);
          }
        }
      });
    },
    submitWorkOrder() {
      let date = moment(this.datefault).format("YYYY-MM-DD");
      let combine = moment(date + " " + this.timefault);
      console.log(combine);
      // console.log(this.selects.simple_contractor)
      let body = {
        EntityID: this.selects.simple_device,
        ContractorID: this.selects.simple_contractor.toString(),
        FaultCodeID: this.selects.simple_fault,
        TimestampFault: combine.format("YYYY-MM-DDThh:mm:ssZ"),
        FaultDetails: this.description,
        Priority: this.selects.simple_priority,
        IsSubmit: true,
        SourceID: this.selects.simple_complaint,
        EntityTypeID: 1,
      };
      console.log(body);

      if (this.isWoAdd) {
        this.$http.post(":8002/api/v1/work-order/new", body).then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal("Successfully Added!", `Work order ${response}!`, "success");
            this.modals.openticket = false;
          } else {
            let response = res.message;
            swal("Something went wrong!", `${response}!`, "warning");
          }
        });
      } else {
        this.$http
          .put(`:8002/api/v1/work-order/new/${this.editWOID}`, body)
          .then((res) => {
            console.log(res);
            if (!res.error) {
              let response = res.message;
              console.log(response);
              swal(
                "Updated!",
                `Work order ${this.editWOID} updated!`,
                "success"
              );
              this.modals.openticket = false;
            }
          });
      }
    },
    updateWorkOrder() {
      let date = moment(this.datefault).format("YYYY-MM-DD");
      let combine = moment(date + " " + this.timefault);

      let body = {
        ContractorID:
          this.selects.simple_contractor == ""
            ? "0"
            : this.selects.simple_contractor.toString(),
        SourceID: this.selects.simple_complaint,
        FaultCodeID: this.selects.simple_fault,
        TimestampFault: combine.format("YYYY-MM-DDThh:mm:ssZ"),
        Priority: this.selects.simple_priority,
        FaultDetails: this.description,
        IsSubmit: false,
      };

      console.log(body);
      this.$http
        .put(`:8002/api/v1/work-order/new/${this.editWOID}`, body)
        .then((res) => {
          console.log(res);
          if (!res.error) {
            this.getWorkOrderNew();
            let response = res.message;
            console.log(response);
            swal("Updated!", `Work order ${this.editWOID} updated!`, "success");
            this.modals.openticket = false;
          }
        });
    },
    createWorkOrder() {
      this.modals.openticket = true;
      this.show = false;
      this.isWoAdd = true;

      this.selects.simple_techType = "";
      this.selects.simple_device = "";
      this.timefault = "";
      this.datefault = "";
      this.description = "";
      this.location = "";
      this.selects.simple_complaint = "";
      this.selects.simple_priority = "";
      this.selects.simple_contractor = 0;
      this.selects.simple_fault = "";
    },
    viewWorkOrder(workOrder) {
      this.sidebar.close();
      
      this.modals.openticket = true;
      this.show = false;
      this.isWoAdd = false;
      this.editWOID = workOrder.woID;
      console.log(workOrder);

      if (workOrder.entityTypeID == 1) {
        this.isNode = true;
        for (let i = 0; i < this.selects.techType.length; i++) {
          if (workOrder.techType == this.selects.techType[i].label) {
            this.selects.simple_techType = this.selects.techType[i].value;
          }
        }

        this.poleID = workOrder.poleID;
      } else {
        this.isNode = false;
      }

      this.selects.simple_device = workOrder.deviceID;
      this.timefault = workOrder.faulttime;
      this.datefault = workOrder.faultdate;
      this.description = workOrder.details;
      this.location = workOrder.locationName;
      this.selects.simple_complaint = workOrder.sourceID;
      this.selects.simple_priority = workOrder.priority;

      for (let i = 0; i < this.selects.contractors.length; i++) {
        if (workOrder.contractor == this.selects.contractors[i].label) {
          this.selects.simple_contractor = this.selects.contractors[i].value;
        }
      }

      for (let i = 0; i < this.selects.fault.length; i++) {
        if (workOrder.fault == this.selects.fault[i].label) {
          this.selects.simple_fault = this.selects.fault[i].value;
        }
      }
    },
    attachSidebar(mapObject) {
      this.sidebar = window.L.control.sidebar({
        autopan: false, // whether to maintain the centered map point when opening the sidebar
        closeButton: true, // whether t add a close button to the panes
        container: "sidebar", // the DOM container or #ID of a predefined sidebar container that should be used
        position: "left", // left or right
      });

      this.sidebar.addTo(mapObject);
    },
  },
  created() {
    this.getWorkOrderNew();
    this.getFaultCode();
    this.getSource();
    this.getContractor();
    this.getTechType();
    this.getTenantDevice();
  },
};
</script>
<style scoped>
.row {
  overflow: hidden;
}
.header h3 {
  display: inline;
}
.inlinethings p {
  display: inline;
}
.drawer {
  position: relative;
  height: 97%;
}
#menuButton {
  position: absolute;
  top: 80px;
  left: 6px;
  padding: 10px;
  z-index: 500;
  font-size: 25px;
}
.legend_attr {
  padding: 5px;
}
.content-card-drawer {
  line-height: 1;
}

.card-style h5 {
  line-height: 1;
}
</style>
